module.exports = {"title":"About me","layout":"page","path":"/about","body":"<p><img src=\"../media/itme.jpg\" alt=\"James A Keene\"></p>\n<hr>\n<p>James A Keene is a software developer based in Brooklyn, NY. It is all but certain that when he dies, he will not have pet enough dogs. Therefore, he tries to pet as many dogs as possible.</p>\n"}


/*****************
 ** WEBPACK FOOTER
 ** ./pages/about/index.md
 ** module id = 476
 ** module chunks = 0
 **/